import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../../axiosinterceptor";

const API = "/code_enhance_review_workflow_episode_list";
const ASSIGN_API = "/ics_episode_assignment_v1";
// const UNASSIGN_API = "/ics_unassignFunctionalityICSV1";
const UNASSIGN_API="/code_enhance_review_workflow_unassign"
const UNASSIGNEPISODES_API = "/ics_unassignedEpisodesICSV1"
// const RECALL_API = "/ics_flag_unflag_episodes_ics_v1"
  const RECALL_API= "/code_enhance_review_workflow_recall"
const RECALLED_EPISODES_API = "/ics_flagged_episodes_ics_v2";
// const REFLAG_API = "/ics_flag_unflag_episodes_ics_v1";
const REFLAG_API = "/code_enhance_review_workflow_recall";

const RECOMMENDATION_API =
  "/ics_search_by_episode_identifier_recommendation_ics_v3";
const AUDIT_SESSION_API =
  "/code_enhance_review_workflow_audit_session";
const COMBINEDUNASSIGNREVIEW_API = "/code_enhance_combined_review_workflow_unassign"
const REFLAGCOMBINEDREVIEW_API =  "/code_enhance_combined_review_workflow_unflag_flag"
const UPDATE_AUDIT_COMMENT_API = "/code_enhance_review_workflow_update_feedback_comment";
export const REQUEST_STATUS = Object.freeze({
  IDLE: "IDLE",
  LOADING: "LOADING",
  SUCCESS: "SUCCESS",
  FAILURE: "FAILURE",
});

const initialState = {
payload: {
  insurer_identifier: [],
  priority_value: [],
  episode_identifier: [],
  status: [],
  file_type: [],
  header_id: [],
  coder_name: [],
  principal_diagonsis: [],
  admission_date_from: "",
  admission_date_to: "",
  separation_date_from: "",
  separation_date_to: "",
  assigned_by: [],
  assigned_to: [],
  audit_ref_no: [],
  audit_rule_category: [],
  medical_record_number:[],
  los_op: "",
  length_of_stay: "",
  uploaded_by_user_name: [],
  hcp_line_updated_at: [],
  short_description: [],
  case_mix_speciality: [],
  drg: [],
  care_type:[],
  page_number: 1,
  page_size: 10,
  is_flagged: false,
  unassigned_page: false,
  sort_by: "",
  sort_order: "",
  is_global: false,
  // additionl keys
  version:"",
  additional_diagnoses: [],
  procedure_codes: [],
  source_of_referral: [],
  mode_of_separation: [],
  load_id: [],
  long_description: [],
  user_message: [],
  recall:false
},
   recommendations: {data: [],status: REQUEST_STATUS.IDLE},
  response: {data: [],status: REQUEST_STATUS.IDLE,error: null},
  assign: {status: REQUEST_STATUS.IDLE,error: null},
  episodeDetails: {data: null,status: REQUEST_STATUS.IDLE,error: null},
  plusFlags: {data: null,status: REQUEST_STATUS.IDLE,error: null},
  auditResults: {data: null,status: REQUEST_STATUS.IDLE,error: null},
  auditChangesTracking: { data: null,status: REQUEST_STATUS.IDLE,error: null},
  saveAuditChanges: {data: null,status: REQUEST_STATUS.IDLE,error: null},
  saveCodingChanges: { data: null, status: REQUEST_STATUS.IDLE, error: null },
  updateStatus: { data: null, status: REQUEST_STATUS.IDLE, error: null },
  unassignEpisode: { data: null, status: REQUEST_STATUS.IDLE, error: null },
  recall: { data: null, status: REQUEST_STATUS.IDLE, error: null },
  reflag: { data: null, status: REQUEST_STATUS.IDLE, error: null },
  codername: { data: [], page: 1, hasMore: true, status: REQUEST_STATUS.IDLE },
  auditSession: { data: null, status: REQUEST_STATUS.IDLE, error: null },
  combinedReviewUnassigned: { data: null, status: REQUEST_STATUS.IDLE, error: null },
 reflagcombinedReview: { data: null, status: REQUEST_STATUS.IDLE, error: null },
updateAuditComment: { data: null, status: REQUEST_STATUS.IDLE, error: null },
};

export const getCodeEnhanceWorkflowViewData = createAsyncThunk(
  "workflow/getCodeEnhanceWorkflowViewData",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const { file_type, file_name, ...apiPayload } = payload;
      const response = await axiosInstance.post(API, apiPayload);
      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
      );
    }
  },
);
export const getEnhanceWorkflowEpisodeDetails = createAsyncThunk(
  "workflow/getEnhanceWorkflowEpisodeDetails",
  async (hcp_line_id, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        "/code_enhance_review_workflow_episode_details",
        {
          params: { hcp_line_id },
        },
      );
      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
      );
    }
  },
);
export const getEnhancePlusFlags = createAsyncThunk(
  "workflow/getEnhancePlusFlags",
  async (hcp_line_id, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/code_enhance_review_workflow_plus_flags",
        { hcp_line_id },
      );

      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
      );
    }
  },
);
export const getEnhanceAuditResults = createAsyncThunk(
  "workflow/getEnhanceAuditResults",
  async (hcp_line_id, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/code_enhance_review_workflow_audit_results",
        { hcp_line_id },
      );
      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
      );
    }
  },
);
export const getAuditChangesTracking = createAsyncThunk(
  "workflow/getAuditChangesTracking",
  async (hcp_line_id, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/code_enhance_review_workflow_get_audit_changes", {
        hcp_line_id,
      });
      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
      );
    }
  },
);

export const saveAuditChangesTracking = createAsyncThunk(
  "workflow/saveAuditChangesTracking",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/code_enhance_review_workflow_post_audit_changes",
        payload,
      );
      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
      );
    }
  },
);
export const saveCodingChanges = createAsyncThunk(
  "workflow/saveCodingChanges",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/code_enhance_review_workflow_save_code_changes",
        payload,
      );
      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
      );
    }
  },
);
export const updateEpisodeStatus = createAsyncThunk(
  "workflow/updateEpisodeStatus",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/code_enhance_review_workflow_status_update",
        payload,
      );
      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Something went wrong",
      );
    }
  },
);
export const assignEpisodes = createAsyncThunk(
  "workflow/assignEpisodes",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(ASSIGN_API, payload);
      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Something went wrong"
      );
    }
  }
);
export const unassignEpisode = createAsyncThunk(
  "workflow/unassignEpisode",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        UNASSIGN_API,
        payload,
      );
      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Something went wrong",
      );
    }
  },
);
export const combinedReviewUnassignEpisode = createAsyncThunk(
  "workflow/combinedReviewUnassignEpisode",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        COMBINEDUNASSIGNREVIEW_API,
        payload,
      );
      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Something went wrong",
      );
    }
  },
);

export const getUnassignedEpisodes = createAsyncThunk(
  "workflow/getUnassignedEpisodes",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        UNASSIGNEPISODES_API,
        payload
      );

      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Something went wrong"
      );
    }
  }
);

export const recallEpisodes = createAsyncThunk(
  "workflow/recallEpisodes",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(RECALL_API, payload);

      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Something went wrong"
      );
    }
  }
);
export const getRecalledEpisodes = createAsyncThunk(
  "workflow/getRecalledEpisodes",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        RECALLED_EPISODES_API,
        payload
      );

      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Something went wrong"
      );
    }
  }
);

export const reflagEpisodes = createAsyncThunk(
  "workflow/reflagEpisodes",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        REFLAG_API,
        payload
      );

      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Something went wrong"
      );
    }
  }
);
export const reflagCombinedReviewEpisodes = createAsyncThunk(
  "workflow/reflagCombinedReviewEpisodes",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        REFLAGCOMBINEDREVIEW_API,
        payload
      );

      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Something went wrong"
      );
    }
  }
);
export const exportEnhanceWorkflowCSV = createAsyncThunk(
  "workflow/exportEnhanceWorkflowCSV",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/code_enhance_review_workflow_export", payload);
      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || "Something went wrong",
      );
    }
  },
);

export const getEpisodeRecommendations = createAsyncThunk(
  "workflow/getEpisodeRecommendations",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(RECOMMENDATION_API, payload);
      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Something went wrong"
      );
    }
  }
);
export const startAuditSession = createAsyncThunk(
  "workflow/startAuditSession",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(AUDIT_SESSION_API, payload);
      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
      );
    }
  },
);
export const checkIfCodeExists = createAsyncThunk(
  "codeEnhance/checkIfCodeExists",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/checkIfCodeExists", // replace with actual API URL
        payload,
      );
      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || "Something went wrong",
      );
    }
  },
);
export const updateAuditComment = createAsyncThunk(
  "workflow/updateAuditComment",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    // payload: { comment_id, updated_comment }
    try {
      const response = await axiosInstance.post(UPDATE_AUDIT_COMMENT_API, payload);
      return fulfillWithValue({ ...response.data, ...payload });
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Something went wrong",
      );
    }
  },
);
const workflowSlice = createSlice({
  name: "workflow",
  initialState,
  reducers: {
    setPayload(state, action) {
      state.payload = {
        ...state.payload,
        ...action.payload,
      };
    },

    resetPayload(state) {
      state.payload = { ...initialState.payload };
    },

    resetResponse(state) {
      state.response = {
        data: [],
        status: REQUEST_STATUS.IDLE,
        error: null,
      };
    },
    resetReflag(state) {
      state.reflag = {
        data: null,
        status: REQUEST_STATUS.IDLE,
        error: null,
      };
    },
    resetEpisodeReviewData(state) {
      state.episodeDetails = { data: null, status: REQUEST_STATUS.IDLE, error: null };
      state.plusFlags = { data: null, status: REQUEST_STATUS.IDLE, error: null };
      state.auditResults = { data: null, status: REQUEST_STATUS.IDLE, error: null };
      state.auditChangesTracking = { data: null, status: REQUEST_STATUS.IDLE, error: null };
      state.saveAuditChanges = { data: null, status: REQUEST_STATUS.IDLE, error: null };
      state.saveCodingChanges = { data: null, status: REQUEST_STATUS.IDLE, error: null };
      state.updateStatus = { data: null, status: REQUEST_STATUS.IDLE, error: null }; // NEW
    },
    resetUpdateStatus(state) {
      state.updateStatus = { data: null, status: REQUEST_STATUS.IDLE, error: null };
    },

    resetUnassignEpisode(state) {
      state.unassignEpisode = { data: null, status: REQUEST_STATUS.IDLE, error: null };
    },

},

  extraReducers: (builder) => {
    builder
      .addCase(getCodeEnhanceWorkflowViewData.pending, (state) => {
        state.response.status = REQUEST_STATUS.LOADING;
        state.response.error = null;
      })

      .addCase(getCodeEnhanceWorkflowViewData.fulfilled, (state, action) => {
        state.response.status = REQUEST_STATUS.SUCCESS;
        state.response.data = action.payload;
      })

      .addCase(getCodeEnhanceWorkflowViewData.rejected, (state, action) => {
        state.response.status = REQUEST_STATUS.FAILURE;
        state.response.error = action.payload;
      })
      .addCase(getEnhanceWorkflowEpisodeDetails.pending, (state) => {
        state.episodeDetails.status = REQUEST_STATUS.LOADING;
        state.episodeDetails.error = null;
      })
      .addCase(getEnhanceWorkflowEpisodeDetails.fulfilled, (state, action) => {
        state.episodeDetails.status = REQUEST_STATUS.SUCCESS;
        state.episodeDetails.data = action.payload;
      })
      .addCase(getEnhanceWorkflowEpisodeDetails.rejected, (state, action) => {
        state.episodeDetails.status = REQUEST_STATUS.FAILURE;
        state.episodeDetails.error = action.payload;
      })
      .addCase(getEnhancePlusFlags.pending, (state) => {
        state.plusFlags.status = REQUEST_STATUS.LOADING;
        state.plusFlags.error = null;
      })
      .addCase(getEnhancePlusFlags.fulfilled, (state, action) => {
        state.plusFlags.status = REQUEST_STATUS.SUCCESS;
        state.plusFlags.data = action.payload;
      })
      .addCase(getEnhancePlusFlags.rejected, (state, action) => {
        state.plusFlags.status = REQUEST_STATUS.FAILURE;
        state.plusFlags.error = action.payload;
      })
      .addCase(getEnhanceAuditResults.pending, (state) => {
        state.auditResults.status = REQUEST_STATUS.LOADING;
        state.auditResults.error = null;
      })
      .addCase(getEnhanceAuditResults.fulfilled, (state, action) => {
        state.auditResults.status = REQUEST_STATUS.SUCCESS;
        state.auditResults.data = action.payload;
      })
      .addCase(getEnhanceAuditResults.rejected, (state, action) => {
        state.auditResults.status = REQUEST_STATUS.FAILURE;
        state.auditResults.error = action.payload;
      })
      .addCase(getAuditChangesTracking.pending, (state) => {
        state.auditChangesTracking.status = REQUEST_STATUS.LOADING;
        state.auditChangesTracking.error = null;
      })
      .addCase(getAuditChangesTracking.fulfilled, (state, action) => {
        state.auditChangesTracking.status = REQUEST_STATUS.SUCCESS;
        state.auditChangesTracking.data = action.payload;
      })
      .addCase(getAuditChangesTracking.rejected, (state, action) => {
        state.auditChangesTracking.status = REQUEST_STATUS.FAILURE;
        state.auditChangesTracking.error = action.payload;
      })
      .addCase(saveAuditChangesTracking.pending, (state) => {
        state.saveAuditChanges.status = REQUEST_STATUS.LOADING;
        state.saveAuditChanges.error = null;
      })
      .addCase(saveAuditChangesTracking.fulfilled, (state, action) => {
        state.saveAuditChanges.status = REQUEST_STATUS.SUCCESS;
        state.saveAuditChanges.data = action.payload;
      })
      .addCase(saveAuditChangesTracking.rejected, (state, action) => {
        state.saveAuditChanges.status = REQUEST_STATUS.FAILURE;
        state.saveAuditChanges.error = action.payload;
      })
      .addCase(saveCodingChanges.pending, (state) => {
        state.saveCodingChanges.status = REQUEST_STATUS.LOADING;
        state.saveCodingChanges.error = null;
      })
      .addCase(saveCodingChanges.fulfilled, (state, action) => {
        state.saveCodingChanges.status = REQUEST_STATUS.SUCCESS;
        state.saveCodingChanges.data = action.payload;
      })
      .addCase(saveCodingChanges.rejected, (state, action) => {
        state.saveCodingChanges.status = REQUEST_STATUS.FAILURE;
        state.saveCodingChanges.error = action.payload;
      })
      .addCase(updateEpisodeStatus.pending, (state) => {
        state.updateStatus.status = REQUEST_STATUS.LOADING;
        state.updateStatus.error = null;
      })
      .addCase(updateEpisodeStatus.fulfilled, (state, action) => {
        state.updateStatus.status = REQUEST_STATUS.SUCCESS;
        state.updateStatus.data = action.payload;
      })
      .addCase(updateEpisodeStatus.rejected, (state, action) => {
        state.updateStatus.status = REQUEST_STATUS.FAILURE;
        state.updateStatus.error = action.payload;
      })
      .addCase(assignEpisodes.pending, (state) => {
        state.assign.status = REQUEST_STATUS.LOADING;
        state.assign.error = null;
      })
      .addCase(assignEpisodes.fulfilled, (state) => {
        state.assign.status = REQUEST_STATUS.SUCCESS;
        state.assign.error = null;
      })
      .addCase(assignEpisodes.rejected, (state, action) => {
        state.assign.status = REQUEST_STATUS.FAILURE;
        state.assign.error = action.payload;
      })
      .addCase(unassignEpisode.pending, (state) => {
        state.unassignEpisode.status = REQUEST_STATUS.LOADING;
        state.unassignEpisode.error = null;
      })
      .addCase(unassignEpisode.fulfilled, (state, action) => {
        state.unassignEpisode.status = REQUEST_STATUS.SUCCESS;
        state.unassignEpisode.data = action.payload;
      })
      .addCase(unassignEpisode.rejected, (state, action) => {
        state.unassignEpisode.status = REQUEST_STATUS.FAILURE;
        state.unassignEpisode.error = action.payload;
      })
      .addCase(combinedReviewUnassignEpisode.pending, (state) => {
        state.combinedReviewUnassigned.status = REQUEST_STATUS.LOADING;
        state.combinedReviewUnassigned.error = null;
      })
      .addCase(combinedReviewUnassignEpisode.fulfilled, (state, action) => {
        state.combinedReviewUnassigned.status = REQUEST_STATUS.SUCCESS;
        state.combinedReviewUnassigned.data = action.payload;
      })
      .addCase(combinedReviewUnassignEpisode.rejected, (state, action) => {
        state.combinedReviewUnassigned.status = REQUEST_STATUS.FAILURE;
        state.combinedReviewUnassigned.error = action.payload;
      })

      .addCase(getUnassignedEpisodes.pending, (state) => {
        state.response.status = REQUEST_STATUS.LOADING;
        state.response.error = null;
      })

      .addCase(getUnassignedEpisodes.fulfilled, (state, action) => {
        state.response.status = REQUEST_STATUS.SUCCESS;
        state.response.data = action.payload;
      })

      .addCase(getUnassignedEpisodes.rejected, (state, action) => {
        state.response.status = REQUEST_STATUS.FAILURE;
        state.response.error = action.payload;
      })

      .addCase(recallEpisodes.pending, (state) => {
        state.recall.status = REQUEST_STATUS.LOADING;
        state.recall.error = null;
      })

      .addCase(recallEpisodes.fulfilled, (state, action) => {
        state.recall.status = REQUEST_STATUS.SUCCESS;
        state.recall.data = action.payload;
      })

      .addCase(recallEpisodes.rejected, (state, action) => {
        state.recall.status = REQUEST_STATUS.FAILURE;
        state.recall.error = action.payload;
      })
      .addCase(getRecalledEpisodes.pending, (state) => {
        state.response.status = REQUEST_STATUS.LOADING;
        state.response.error = null;
      })

      .addCase(getRecalledEpisodes.fulfilled, (state, action) => {
        state.response.status = REQUEST_STATUS.SUCCESS;
        state.response.data = action.payload;
      })

      .addCase(getRecalledEpisodes.rejected, (state, action) => {
        state.response.status = REQUEST_STATUS.FAILURE;
        state.response.error = action.payload;
      })

      .addCase(reflagEpisodes.pending, (state) => {
        state.reflag.status = REQUEST_STATUS.LOADING;
        state.reflag.error = null;
      })

      .addCase(reflagEpisodes.fulfilled, (state, action) => {
        state.reflag.status = REQUEST_STATUS.SUCCESS;
        state.reflag.data = action.payload;
      })

      .addCase(reflagEpisodes.rejected, (state, action) => {
        state.reflag.status = REQUEST_STATUS.FAILURE;
        state.reflag.error = action.payload;
      })
      .addCase(reflagCombinedReviewEpisodes.pending, (state) => {
        state.reflagcombinedReview.status = REQUEST_STATUS.LOADING;
        state.reflagcombinedReview.error = null;
      })

      .addCase(reflagCombinedReviewEpisodes.fulfilled, (state, action) => {
        state.reflagcombinedReview.status = REQUEST_STATUS.SUCCESS;
        state.reflagcombinedReview.data = action.payload;
      })

      .addCase(reflagCombinedReviewEpisodes.rejected, (state, action) => {
        state.reflagcombinedReview.status = REQUEST_STATUS.FAILURE;
        state.reflagcombinedReview.error = action.payload;
      })
      .addCase(getEpisodeRecommendations.pending, (state) => {
        state.recommendations.status = REQUEST_STATUS.LOADING;
      })

      .addCase(getEpisodeRecommendations.fulfilled, (state, action) => {
        state.recommendations.status = REQUEST_STATUS.SUCCESS;
        state.recommendations.data =
          action.payload.unique_episode_identifiers || [];
      })

      .addCase(getEpisodeRecommendations.rejected, (state) => {
        state.recommendations.status = REQUEST_STATUS.FAILURE;
        state.recommendations.data = [];
      })
      .addCase(startAuditSession.pending, (state) => {
        state.auditSession.status = REQUEST_STATUS.LOADING;
        state.auditSession.error = null;
      })
      .addCase(startAuditSession.fulfilled, (state, action) => {
        state.auditSession.status = REQUEST_STATUS.SUCCESS;
        state.auditSession.data = action.payload;
      })
      .addCase(startAuditSession.rejected, (state, action) => {
        state.auditSession.status = REQUEST_STATUS.FAILURE;
        state.auditSession.error = action.payload;
      })
      .addCase(updateAuditComment.pending, (state) => {
  state.updateAuditComment.status = REQUEST_STATUS.LOADING;
  state.updateAuditComment.error = null;
})
.addCase(updateAuditComment.fulfilled, (state, action) => {
  state.updateAuditComment.status = REQUEST_STATUS.SUCCESS;
  state.updateAuditComment.data = action.payload;
})
.addCase(updateAuditComment.rejected, (state, action) => {
  state.updateAuditComment.status = REQUEST_STATUS.FAILURE;
  state.updateAuditComment.error = action.payload;
})

  },
});

export const {
  setPayload,
  resetPayload,
  resetResponse,
  resetEpisodeReviewData,
  resetUpdateStatus,
  resetUnassignEpisode,
  resetReflag,
  resetFilters
} = workflowSlice.actions;
export const initialPayload = initialState.payload;
export default workflowSlice.reducer;